import { revalidateRelatedInputs, setupFormValidation } from '@/utility/functions';

window.addEventListener('vueloaded', () => {
  let $register = document.getElementById('register-form');

  if($register) {
    setupFormValidation($register);

    // detect IE11
    if(!(!!window.MSInputMethodContext && !!document.documentMode)) {
      const $same_as = document.querySelectorAll('same_as');

      for(var i = 0; i < $same_as.length; i++) {
        $same_as[i].addEventListener('change', () => {
          revalidateRelatedInputs($same_as);
        });
      }
    }
  }
});
